import { Suspense } from 'react';
import { useLazyObjectUrls } from '../../../../../hooks/useLazyObjectUrls';
import { lazyWithReload } from '../../../../../utils/lazyWithReload';
import type { ScanMeshSet } from './scanZip';
import { ViewerMessage } from './ViewerMessage';

const FullStlViewer = lazyWithReload(() =>
    import('@odo/shared-ui/components/stl/FullStlViewer').then((m) => ({ default: m.default }))
);

const OPENING_TITLE = 'Opening the 3D files…';

interface ScanMeshViewerProps {
    meshes: ScanMeshSet;
}

// Every STL in the export is offered in the slot pickers; the best upper and lower start loaded.
export function ScanMeshViewer({ meshes }: ScanMeshViewerProps) {
    const getFileUrl = useLazyObjectUrls(meshes.loadMesh);
    if (!getFileUrl) return <ViewerMessage title={OPENING_TITLE} busy />;
    return (
        <Suspense fallback={<ViewerMessage title={OPENING_TITLE} busy />}>
            <FullStlViewer
                files={meshes.files}
                getFileUrl={getFileUrl}
                initialSlots={meshes.preselect}
            />
        </Suspense>
    );
}
